<template>
    <div v-if="visible" :class="['window-abstract', { 'mounted': mounted }]">

        <slot></slot>

    </div>
</template>

<script>
import { mapGetters } from '@generio-ai/library-legacy/plugins/vuex'

export default {
    name: 'WindowAbstract',
    data() {
        return {
            mounted: false
        }
    },
    computed: {
        ...mapGetters('windows', {
            isWindowVisible: 'isVisible'
        }),
        visible: {
            get() {
                return this.isWindowVisible
            },
            set(value) {
                if (value === false) this.close()
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.mounted = true
        })
    }
}
</script>

<style scoped>
.window-abstract {
    width: 100%;
    height: 100%;
    display: flex;
    border: 1px solid rgb(var(--v-theme-lightbase));
    border-radius: 8px;
    background-color: rgb(var(--v-theme-darkbase));
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
    opacity: 0;
    transition: box-shadow 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
}

.window-abstract.mounted {
    box-shadow: 0px 0px 20px rgb(var(--v-theme-color1), 0.2);
    opacity: 1;
}

@media (max-width: 800px) {
    .window-abstract {
        height: 85vh;
    }
}

@media (max-width: 600px) {
    .window-abstract {
        height: 75vh;
    }
}

@media (max-width: 450px) {
    .window-abstract {
        border-radius: 0px;
    }
}
</style>
